import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdFolder,
  MdFolderOpen,
  MdInsertDriveFile
} from "react-icons/md";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AdminUserProfile extends Component {
    constructor() {
        super();

        this.handleChangeDivisions = this.handleChangeDivisions.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleCustomWorkspace = this.handleCustomWorkspace.bind(this)

        sessionStorage.setItem('session_customer_custom_workspace_id',null)    

        this.state = {
            is_loaded: false,
            has_error: false,
            error_message: '',
            redirect_users: false,
            customer_id: null,
            divisions: [],
            menus: null,
            id: null,
            user: null,
            customer_group_id: null,
            customer_custom_workspace_id: null,             
            checked: [],
            expanded: [],
            nodes: [],
            user_id: null,
            checkedma: [],
            expandma: [],
            nodesma: []                        
        }
    }

    setError(message){
        this.setState({has_error: true, error_message: message});
    }

    setRedirect() {
        this.setState({redirect_users: true});
    }

    componentDidMount() {
        // get customer model
        console.log('componentDidMount');
        const user_id = this.props.match.params.uid;
        const customer_id = this.props.match.params.cid;
                
        if (!user_id) {
            this.setState({ is_loaded: true, id: null, user: null, customer_id: customer_id});
            return;
        }

        var customer;   
        var customer_group_id;     
        var customer_custom_workspace_id;        
        const urii = config.getUriPath('customers/' + customer_id)
        fetch(urii, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {            
            customer = data;
            customer_group_id = customer.customer_group_id;
            customer_custom_workspace_id = customer.customer_custom_workspace_id;                    
            //console.log(customer_group_id);
            //console.log('customer_custom_workspace_id: ' + customer_custom_workspace_id);
            sessionStorage.setItem('session_customer_custom_workspace_id',customer_custom_workspace_id)
          });

        if (user_id === "new") {
            const acumen = (customer_id === config.AcumenAdminName);
            const data = {
                customer_id: customer_id,
                security_role: acumen ? config.SecurityRoles.systemAdmin : config.SecurityRoles.user,
                department: "",
                title: "",
                email_address: "",
                given_name: "",
                family_name: ""
            };

            this.fetchUserMenuNew(user_id, data, customer_id,customer_group_id,customer_custom_workspace_id );
            //this.fetchBusinessDivisions(user_id, data, customer_id,customer_group_id);
            //this.setState({ is_loaded: true, id: user_id, user: data, customer_id: customer_id });
            return;
        }

        var that = this;
        const uri = config.getUriPath('users/profile/' + user_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {               
                that.fetchUserMenu(user_id, data, customer_id,customer_group_id,customer_custom_workspace_id );
          });
    }

    fetchUserMenu(user_id, user, customer_id,customer_group_id,customer_custom_workspace_id)
    {
        //console.log('fetchUserMenu');
        var that = this;
        const uri = config.getUriPath('users/menu/' + user_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {                                           
                that.fetchBusinessDivisions(user_id, user, customer_id,customer_group_id,customer_custom_workspace_id,data);
          });

    }

    fetchUserMenuNew(user_id, user, customer_id,customer_group_id,customer_custom_workspace_id)
    {
        //console.log('fetchUserMenuNew');
        var that = this;
        const uri = config.getUriPath('users/menu/' + 'New' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {                                           
                that.fetchBusinessDivisions(user_id, user, customer_id,customer_group_id,customer_custom_workspace_id,data);
          });
    }

    fetchBusinessDivisions(user_id, user, customer_id,customer_group_id,customer_custom_workspace_id,menus){
        //console.log('fetchBusinessDivisions');
        var that = this;
        that.fetchTreeNode(user_id,user,customer_id,[],customer_group_id,customer_custom_workspace_id,menus); 
        /*
        const uri = config.getUriPath('businessdivisions/all/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) { 
                that.fetchTreeNode(user_id,user,customer_id,data,customer_group_id,customer_custom_workspace_id,menus);                
          });
          */
    }  

    fetchTreeNode(user_id, user, customer_id,divisions,customer_group_id,customer_custom_workspace_id,menus) {
        console.log('fetchTreeNode');
        var that = this;        
        let uri = config.getAcumenAPIURL('customer/' + customer_id + '/visuals');        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix()); 

        fetch(uri, {
                method: 'get',
                headers: myHeaders
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {  
                console.log(data.nodes);              
                that.fetchUserChecked(user_id,user,customer_id,divisions,customer_group_id,customer_custom_workspace_id,menus,data.nodes);
            });
    }

    fetchUserChecked(user_id, user, customer_id,divisions,customer_group_id,customer_custom_workspace_id,menus,nodes)
    {
        console.log('fetchUserChecked');
        var that = this;        
        if (user_id === 'new')
        {
            //that.setState({is_loaded: true, id: user_id, user: user, customer_id: customer_id, divisions: divisions, customer_group_id:customer_group_id,customer_custom_workspace_id:customer_custom_workspace_id, menus:menus,nodes:nodes, user_id: user_id});
            var user_checked = [];
            that.fetchTreeNodeMA(user_id, user, customer_id, divisions, customer_group_id, customer_custom_workspace_id, menus, nodes, user_checked);
        }
        else
        { 
            let geturi = config.getAcumenAPIURL('api/user/visuals/' + user_id);        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix());

            var user_checked = [];
            fetch(geturi, {
            method: 'get',
            headers: myHeaders
            }).then(function(response) {
            if (response.status >= 400) {
            throw new Error("Bad response from server");
            }
            return response.json();
            })
            .then(function(data) {                
                user_checked = data.visuals;
                console.log(user_checked);
                //that.setState({is_loaded: true, id: user_id, user: user, customer_id: customer_id, divisions: divisions, customer_group_id:customer_group_id,customer_custom_workspace_id:customer_custom_workspace_id, menus:menus,nodes:nodes, checked: user_checked, user_id: user_id});
                that.fetchTreeNodeMA(user_id, user, customer_id, divisions, customer_group_id, customer_custom_workspace_id, menus, nodes, user_checked);
            });
        }
    }

    fetchTreeNodeMA(user_id, user , customer_id, divisions, customer_group_id, customer_custom_workspace_id, menus, nodes, checked)
    {
        var that = this;        
        console.log('fetchTreeNodeMA')  
        let uri = config.getAcumenAPIURL('customer/' + customer_id + '/folders');        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix());

        fetch(uri, {
                method: 'get',
                headers: myHeaders
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {                  
                console.log(data.folders)   
                var foldernodes = []
                for(var folder of data.folders)           
                {
                    var fi = {"label":folder['folder_name'],"value":folder['id']}
                    foldernodes.push(fi);
                }
                console.log(foldernodes);
                that.fetchFolderChecked(user_id, user , customer_id, divisions, customer_group_id, customer_custom_workspace_id, menus, nodes, checked, foldernodes);
            });
    }
    
    fetchFolderChecked(user_id, user , customer_id, divisions, customer_group_id, customer_custom_workspace_id, menus, nodes, checked, nodesma)
    {
        console.log('fetchFolderChecked')      
        var that = this; 
        var folder_checked = {'folders':[]};

        
        if (user_id === 'new')
        {   
            console.log('fetchFolderChecked new');
            console.log(folder_checked.folders);   
            that.setState({is_loaded: true, id: user_id, user: user, customer_id: customer_id, divisions: divisions, customer_group_id:customer_group_id,customer_custom_workspace_id:customer_custom_workspace_id, menus:menus,nodes:nodes, checked: checked, user_id: user_id, nodesma: nodesma, checkedma: folder_checked.folders});
        }
        else
        {
        
            console.log('fetchFolderChecked user_id')
            let geturi = config.getAcumenAPIURL('api/user/folders/' + user_id);        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix());
           
            fetch(geturi, {
            method: 'get',
            headers: myHeaders
            }).then(function(response) {
            if (response.status >= 400) {
            throw new Error("Bad response from server");
            }
            return response.json();
            })
            .then(function(data) {                
                folder_checked = data.folders;
                console.log(folder_checked);                
                that.setState({is_loaded: true, id: user_id, user: user, customer_id: customer_id, divisions: divisions, customer_group_id:customer_group_id,customer_custom_workspace_id:customer_custom_workspace_id, menus:menus,nodes:nodes, checked: checked, user_id: user_id, nodesma: nodesma, checkedma: folder_checked}); 
                
            });            
        }
    }

    handleSave(event) {
        event.preventDefault();

        var that = this;
        const id = this.state.id;
        const auser = this.state.user;
        let uriId = '';
        let method;

        var emessage = '';

        const acumen = (this.state.customer_id === config.AcumenAdminName);

        if (!auser.given_name){
            emessage = emessage + ' First name is required.';            
        }

        if (!auser.family_name){
            emessage = emessage + ' Last name is required.';            
        }

        if (!auser.email_address){
            emessage = emessage + ' Email is required.';            
        }
        
        if(!acumen)
        {
            if (!auser.title){
                emessage = emessage + ' Title is required.';            
            }

            if (!auser.department){
                emessage = emessage + ' Department is required.';            
            }

            if (!auser.security_role){
                emessage = emessage + ' Security Role is required.';            
            }
        }

        if(emessage != '')
        {            
            this.setError(emessage);
            return;
        }

        if (id === "new") {
            uriId = 'identity/' + this.state.customer_id;
            method = 'post';
        } else {
            uriId = 'identity/' + id;
            method = 'put';
        }

        //console.log(this.state.user)
        const uri = config.getUriPath(uriId);
        fetch(uri, {
            method: method,
            headers: config.ApiHeaders(),
            body: JSON.stringify(this.state.user)
        }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }
            console.log('USER SAVE');
            that.SaveVisuals(event);            
        }); 
    }

    SaveVisuals(event)
    {
        event.preventDefault();
        var that = this;
        const id = this.state.id;
        const auser = this.state.user;
        var the_user_id = '';
        
        if (id === "new") 
        {
            //new
            let useriduri = config.getAcumenAPIURL('api/user/userid/');        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix());
            myHeaders.append("el", auser.email_address);

            fetch(useriduri, {method: 'get',headers: myHeaders})
                .then(function(response)
                {
                    if (response.status >= 400) 
                    {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function(data) 
                {    
                    console.log('GetUserID ' + data.user_id);
                    the_user_id = data.user_id;
                                                           
                    let vizuri = config.getAcumenAPIURL('api/user/visuals/' + the_user_id);
                    var updatejson = {"user_id" : the_user_id, "customer_id" : that.state.customer_id, "visuals": that.state.checked, "folders": that.state.checkedma}         
                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
                    myHeaders.append("table-prefix", config.getTablePrefix());

                    fetch(vizuri, {
                        method: 'post',
                        headers: myHeaders,
                        body: JSON.stringify(updatejson)
                    }).then(function(response) {
                        //console.log(response.status);
                        //console.log(response.json());            
                        if (response.status >= 400) {
                          //console.log(response);
                          throw new Error("Bad response from server");
                        }
                        console.log('SAVED Viz');
                        that.setRedirect();   
                    });
                });
        }
        else
        {
            //update
            the_user_id = id;
            
            let vizuri = config.getAcumenAPIURL('api/user/visuals/' + the_user_id);
            var updatejson = {"user_id" : the_user_id, "customer_id" : that.state.customer_id, "visuals": that.state.checked, "folders": that.state.checkedma}         
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix());
            
                fetch(vizuri, {
                    method: 'post',
                    headers: myHeaders,
                    body: JSON.stringify(updatejson)
                }).then(function(response) {
                    //console.log(response.status);
                    //console.log(response.json());            
                    if (response.status >= 400) {
                        console.log(response);
                        throw new Error("Bad response from server");
                    }
                    console.log('SAVED Viz');
                    that.setRedirect();   
                });           
        } 
    }  

    handleDelete(event) {
        event.preventDefault();

        const canDel = window.confirm('Are you sure you want to delete this user?');
        
        if (canDel === false) {
            return;
        }

        var that = this;

        const uri = config.getUriPath('identity/' + this.state.id)
        fetch(uri, {
            method: 'delete',
            headers: config.ApiHeaders()
        }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleCancel(event) {
        event.preventDefault();

        this.setRedirect();        
    }

    handleChange(event) {
        let data = this.state.user;
        data[event.target.name] = event.target.value;
        this.setState({user: data});
    }

    handleChangeDivisions(e) {
        let user = this.state.user;
        if (e.target.checked) {
            user.divisions.push(e.target.name);
        } else {
            user.divisions = user.divisions.filter(x => x !== e.target.name);
        }

        this.setState({user: user});
    }

    handleCustomWorkspace(e) {
        let user = this.state.user;
        
        /*
        if (e.target.checked) {
            user.show_custom_workspace = 1;
        } else {
            user.show_custom_workspace = 0;
        }
        */

        user.show_custom_workspace = e.target.value;
        this.setState({user: user});
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div>Loading...</div>
        }

        if (this.state.redirect_users){
            return <Redirect to={'/admin/users/' + this.state.customer_id} />
        }

        const {id, user} = this.state;
        if (!id || !user) {
            return <h1>No user selected</h1>
        }

        if (!user.divisions) {
            user.divisions = [];
        }

        const isNew = (id === "new");
        const acumen = (this.state.customer_id === config.AcumenAdminName);
        const className = acumen === false ? '' : 'hidden';
        const title = isNew ? "Create New User" : "Edit Profile: " + user.family_name + ", " + user.given_name
        var ShowCustomWorkspace = false;                
        
        if (sessionStorage.getItem('session_customer_custom_workspace_id') !== 'null')
        {
            console.log('session_customer_custom_workspace_id ' + sessionStorage.getItem('session_customer_custom_workspace_id'));
            ShowCustomWorkspace = true;
        }
        //console.log('ShowCustomWorkspace ' + ShowCustomWorkspace);
        //console.log('user.show_custom_workspace ' + user.show_custom_workspace);
        //console.log(user);

        var defaultmenus = []
        //console.log('defaultmenus');
        //console.log(this.state.nodes);
        var nds = this.state.nodes;
        var ndslen = nds.length;
        //console.log(ndslen);
        for (var i = 0; i< ndslen;i++)
        {
            var children = nds[i].children;
            var childrenlen = children.length;
            for(var y = 0; y < childrenlen; y++)
            {
                var itm = {"title": children[y].label, "url" : "/visualizations/view/" + children[y].value + "/" + this.state.customer_group_id};
                defaultmenus.push(itm);                
            }            
        } 
        //sort dropdown alphabetically
        defaultmenus.sort((a, b) => 
        {
            if (a.title < b.title)
              return -1;
            if (a.title > b.title)
              return 1;
            return 0;
          }
        );

        const icons = {
            check: <MdCheckBox className="rct-icon rct-icon-check" />,
            uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
            halfCheck: (
              <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
            ),
            expandClose: (
              <MdChevronRight className="rct-icon rct-icon-expand-close" />
            ),
            expandOpen: (
              <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />
            ),
            expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
            collapseAll: (
              <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
            ),
            parentClose: <MdFolder className="rct-icon rct-icon-parent-close" />,
            parentOpen: <MdFolderOpen className="rct-icon rct-icon-parent-open" />,
            leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
          };                  

        return <div>
                    <div className="center-div">
                        <h1>{title}</h1>
                    </div>
                    <br />
                    <div className="form-wrapper-userprofile">
                        <form>
                            <div className="container-fluid">
                                <div>
                                    <label className="requiredbefore">requried fields</label>
                                </div>  
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="given_name" className="required">First Name:</label>
                                            <input type="text" onChange={this.handleChange} className="form-control" placeholder="First Name" name="given_name" defaultValue={user.given_name}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="family_name" className="required">Last Name:</label>
                                            <input type="text" onChange={this.handleChange} className="form-control" placeholder="Last Name" name="family_name" defaultValue={user.family_name} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email_address" className="required">Email Address:</label>
                                            <input type="email" onChange={this.handleChange} className="form-control" placeholder="Email" name="email_address" defaultValue={user.email_address} />
                                        </div>
                                        <div className={[className, "form-group"].join(' ')}>
                                            <label htmlFor="title" className="required">Title:</label>
                                            <input type="text" onChange={this.handleChange} className="form-control" placeholder="Title" name="title" defaultValue={user.title} />
                                        </div>
                                        <div className={[className, "form-group"].join(' ')}>
                                            <label htmlFor="department" className="required">Department:</label>
                                            <input type="text" onChange={this.handleChange} className="form-control" placeholder="Department"  name="department" defaultValue={user.department} />
                                        </div>
                                        <div className={[className, "form-group"].join(' ')}>
                                            <label htmlFor="security_role" className="required">Security Role:</label>
                                            <div>
                                                <select name="security_role" className="form-control" onChange={this.handleChange} defaultValue={user.security_role}>
                                                    <option value="" disabled selected hidden>Security Role</option>
                                                    <option value={config.SecurityRoles.user}>User</option>
                                                    <option value={config.SecurityRoles.customerAdmin}>Administrator</option>
                                                </select>
                                            </div>
                                        </div>                                
                                        <div className={[className, "form-group"].join(' ')}>   
                                            <label htmlFor="user_default_link" className="required">Default Page:</label>
                                            <div>
                                                <select name="user_default_link" className="form-control" onChange={this.handleChange} defaultValue={user.user_default_link}>
                                                    <option value="" disabled selected hidden>Default Page</option>
                                                    {defaultmenus.map((item) => {
                                                    return (
                                                        <option value={item.url}>{item.title}</option>                                           
                                                    )
                                                    })}
                                                </select>
                                            </div>
                                        </div>                                         
                                    </div>
                                    <div className="col profilecol2">                                        

                                        <div className={acumen ? "hidden" : "dashboard-roles role-checkboxes"}>
                                            <h3>Manage Access</h3>
                                            <div className="form-group">
                                                <CheckboxTree
                                                    nodes={this.state.nodes}
                                                    checked={this.state.checked}
                                                    expanded={this.state.expanded}
                                                    onCheck={checked => this.setState({ checked })}
                                                    onExpand={expanded => this.setState({ expanded })}
                                                    icons={icons}
                                                />
                                            </div>
                                        </div>                

                                        <div className={ShowCustomWorkspace ? "dashboard-roles role-checkboxes" : "hidden"}> 
                                            <div className="form-group">                                                  
                                                <div>
                                                    <label htmlFor="show_custom_workspace">myAcumen:</label>
                                                    <select name="show_custom_workspace" className="form-control" onChange={this.handleCustomWorkspace} defaultValue={user.show_custom_workspace}>
                                                        <option value="0">No Access</option>
                                                        <option value="1">Full Access</option>
                                                        <option value="2">Edit Access</option>
                                                        <option value="3">View Only Access</option>
                                                    </select>
                                                </div>                                                
                                            </div>
                                            <div className="form-group">                                                
                                                <div>
                                                    <CheckboxTree
                                                        nodes={this.state.nodesma}
                                                        checked={this.state.checkedma}
                                                        expanded={this.state.expandedma}
                                                        onCheck={checkedma => this.setState({ checkedma })}
                                                        onExpand={expandedma => this.setState({ expandedma })}
                                                        iconsClass="fa5"
                                                        icons={{
                                                            check: <span className="rct-icon rct-icon-check myacumencheck" />,
                                                            uncheck: <span className="rct-icon rct-icon-uncheck myacumencheck" />,
                                                            halfCheck: <span className="rct-icon rct-icon-half-check" />,
                                                            expandClose: <span className="rct-icon rct-icon-expand-close" />,
                                                            expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                                                            expandAll: <span className="rct-icon rct-icon-expand-all" />,
                                                            collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                                                            parentClose: <span className="rct-icon rct-icon-parent-close" />,
                                                            parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                                                            leaf: <span className="fas fa-folder myacumenfolder" />,
                                                        }}
                                                    />    
                                                </div>        
                                            </div>      
                                        </div>

                                    </div>                                    
                                </div>
                            </div>

                                
                                
                                

                                <div className="form-group">
                            
                            

                            

                        </div>
                       
                        <div className={this.state.has_error ? "form-group" : "hidden"}>
                            <div className="errorMsg">{this.state.error_message}</div>
                        </div>
                        <div className="form-group">
                            <div className="centerAlign" colSpan="2">
                                <button onClick={this.handleSave} name="save" className="loginButton btn btn-primary">Save</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleDelete} name="delete" className={isNew ? "hidden" : "loginButton btn btn-danger"}>Delete</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleCancel} name="cancel" className="loginButton btn btn-info">Cancel</button>
                            </div>
                        </div>
                        </form>
                    </div>
            </div>
    }
}

export default AdminUserProfile


// WEBPACK FOOTER //
// ./src/Components/AdminUsers/AdminUserProfile.js